/* Product catalogue for Kurotsuki.
   Products with listed:false stay in the data but are not shown in the shop yet.
   Fill in steel / hardness / origin once the supplier confirms them: empty values are hidden. */
const SHOW_REVIEWS = false;          // set to true once real reviews exist
const REVIEWS = [];                  // { quote: "...", author: "Naam, plaats" }

const PRODUCTS = [
  {
    id: "gyuto-240", kind: "kok", style: "nami",
    name: "Gyuto Koksmes",
    category: "Gyuto",
    price: 189.00,
    oldPrice: null,
    rating: 0,
    reviews: 0,
    badge: null,
    short: "Golvend damast. Rustige snede.",
    inspo: "Japanse Gyuto",
    steel: "",
    handle: "Gelakt pakkahout",
    hardness: "",
    length: "20 cm lemmet", totalLength: "33,5 cm", width: "4 cm", weight: "188 g",
    origin: "",
    features: [
      "Golvend damast: lemmet van 20 cm met een golvend patroon",
      "Gelakt hout: gelamineerd handvat dat rustig en warm in de hand ligt",
      "Japanse Gyuto: geïnspireerd op het Japanse koksmes",
      "Veelzijdig: voor ui, vis, vlees en kruiden"
    ],
    desc: "De Gyuto is een koksmes voor ui, vis, vlees en kruiden. Een lang lemmet met een licht gebogen snede, gemaakt om te wiegen en te glijden. Het handvat van gelamineerd hout ligt rustig en warm in de hand.",
    why: "Een koksmes voor ui, vis, vlees en kruiden. Een lang lemmet met een licht gebogen snede, gemaakt om te wiegen en te glijden.",
    gauge: {
      ratios: [2400 / 385],
      knives: [{ asset: 0, turn: { count: 56, ratio: 2206 / 420, inner: { left: 0.0522, top: 0.1231, width: 0.8947, height: 0.7539 }, m: "dikte", text: "2 mm", x: 0.32, ay: 0.375 }, marks: {
        lemmet: { type: "span", from: 0, to: 0.6, text: "20 cm" },
        totaal: { type: "span", from: 0, to: 1, text: "33,5 cm", row: 2 },
        gewicht: { type: "glow", from: 0, to: 1 }
      } }],
      stats: [
        { k: 0, m: "lemmet", v: "20", u: "cm", l: "lemmet" },
        { k: 0, m: "totaal", v: "33,5", u: "cm", l: "totale lengte" },
        { k: 0, m: "dikte", v: "2", u: "mm", l: "dikte lemmet" },
        { k: 0, m: "gewicht", v: "188", u: "g", l: "gewicht" }
      ]
    },
    upsell: { handle: "complete-set", title: "Liever allebei de Gyuto's?" },
    highlights: [{ v: "20", u: "cm", l: "lemmet" }, { v: "33,5", u: "cm", l: "totale lengte" }, { v: "188", u: "g", l: "gewicht" }],
    svg: "knife-gyuto",
    photo: "img/products/gyuto-240-cover.jpg",
    photoWide: "img/products/gyuto-240-cover.jpg",
    photoFit: "cover",
    gallery: [
      "img/products/gyuto-240-cover.jpg",
      "img/products/gyuto-240-studio-main.jpg",
      "img/products/gyuto-240-studio-h.jpg",
      "img/products/gyuto-240-studio-handle.jpg",
      "img/products/gyuto-240-studio.jpg"
    ],
    detailImg: "img/products/gyuto-240-studio-handle.jpg",
    anno: {
      photo: "img/products/gyuto-240-cover.png", aspect: 0.5441,
      points: { handle: [0.735, 0.191], heel: [0.565, 0.415], blade: [0.327, 0.718], tip: [0.034, 0.978] },
      bladeTitle: "het lemmet · 20 cm",
      notes: {
        handle: "Gelamineerd hout. Ligt warm en zwaar in de hand.",
        heel: "Waar hand en staal elkaar ontmoeten.",
        blade: "Een golvend patroon, als water in hout.",
        tip: "Voor het fijne werk: sjalot, kruiden, vis."
      }
    }
  },
  {
    id: "santoku-180", kind: "kok", style: "nami", comingSoon: true, soldOut: true,
    name: "Santoku 18 cm",
    category: "Santoku",
    price: 129.00,
    oldPrice: null,
    rating: 0,
    reviews: 0,
    badge: null,
    short: "Korter, breder en rustiger. Voor het precieze werk.",
    inspo: "Japanse Santoku, 'de drie deugden'",
    steel: "",
    handle: "Gelakt pakkahout",
    hardness: "",
    length: "18 cm lemmet",
    origin: "",
    features: [
      "18 cm lemmet met een golvend patroon",
      "Handvat van gelakt, gelamineerd hout",
      "Geïnspireerd op de Japanse Santoku",
      "Gemaakt voor dunne plakken en fijne bosjes"
    ],
    desc: "De Santoku, 'de drie deugden', snijdt, hakt en schaaft. Het brede, iets kortere lemmet geeft controle bij fijn snijwerk: dunne plakken, fijne bosjes, één ferme haal. Een compact mes dat in elke keuken thuishoort.",
    svg: "knife-santoku",
    photo: "img/products/santoku-180-cover.jpg",
    photoWide: "img/products/santoku-180-cover.jpg",
    photoFit: "cover",
    gallery: [
      "img/products/santoku-180.png",
      "img/products/santoku-180-h.png",
      "img/products/santoku-180-handle.jpg",
      "img/products/santoku-180-blade.jpg"
    ],
    detailImg: "img/products/santoku-180-handle.jpg",
    anno: {
      photo: "img/products/santoku-180.png", aspect: 0.591,
      points: { handle: [0.72, 0.22], heel: [0.42, 0.44], blade: [0.30, 0.68], tip: [0.06, 0.97] },
      bladeTitle: "het lemmet · 18 cm",
      notes: {
        handle: "Gelamineerd hout. Rustig en licht in de hand.",
        heel: "Waar hand en staal elkaar ontmoeten.",
        blade: "Breed en vlak, met een golvend patroon.",
        tip: "Voor dunne plakken en fijne bosjes."
      }
    }
  },
  {
    id: "gyuto-tsuchime", kind: "kok", style: "tsuchime",
    name: "Gyuto Koksmes Tsuchime",
    category: "Gyuto",
    price: 189.00, // PLACEHOLDER: same as the damascus Gyuto until the real price is set
    oldPrice: null,
    rating: 0,
    reviews: 0,
    badge: null,
    short: "Het koksmes voor ui, vis, vlees en kruiden, met een gehamerd lemmet.",
    inspo: "Japanse Gyuto", handle: "African rosewood, achthoekig", use: "Groenten, vlees, vis en kruiden",
    why: "Een koksmes voor ui, vis, vlees en kruiden, met een zwart gesmeed lemmet met een gehamerd, onregelmatig patroon. Onder de gehamerde rand loopt een gepolijste snijkant.",
    gauge: {
      ratios: [2400 / 349],
      knives: [{ asset: 0, turn: { count: 56, ratio: 1500 / 272, inner: { left: 0.0496, top: 0.097, width: 0.9007, height: 0.7225 }, m: "dikte", text: "2 mm", x: 0.32, ay: 0.30 }, marks: {
        lengte: { type: "span", from: 0, to: 0.6, text: "21 cm" },
        breedte: { type: "bracket", x: 0.5, y0: 0.09, y1: 0.98, text: "4,8 cm" },
        hardheid: { type: "glow", from: 0, to: 0.6 }
      } }],
      stats: [
        { k: 0, m: "lengte", v: "21", u: "cm", l: "lengte" },
        { k: 0, m: "breedte", v: "4,8", u: "cm", l: "breedte lemmet" },
        { k: 0, m: "dikte", v: "2", u: "mm", l: "dikte lemmet" },
        { k: 0, m: "hardheid", v: "56–58", u: "HRC", l: "hardheid" }
      ]
    },
    upsell: { handle: "complete-set", title: "Liever allebei de Gyuto's?" },
    highlights: [{ v: "21", u: "cm", l: "lengte" }, { v: "4,8", u: "cm", l: "breedte lemmet" }, { v: "2", u: "mm", l: "dikte lemmet" }, { v: "56–58", u: "HRC", l: "hardheid" }],
    length: "21 cm (8,3 inch)", bladeWidth: "4,8 cm (1,9 inch)", thickness: "2 mm", hardness: "56–58 HRC", finish: "Zwart gesmeed (black forged)",
    features: [
      "Gehamerd lemmet: zwart gesmede afwerking met een gepolijste snijkant eronder",
      "African rosewood: achthoekig handvat met zwart tussenstuk en messing ring",
      "Afmetingen: lemmet van 21 cm en 2 mm dik, hardheid 56–58 HRC"
    ],
    desc: "Een koksmes met een gehamerde afwerking op het lemmet: een rustig, onregelmatig hamerpatroon boven een gepolijste snijkant. Het achthoekige handvat van African rosewood heeft een zwart tussenstuk en een dun messing randje. Elk mes ziet er daardoor net iets anders uit.",
    photo: "img/products/gyuto-tsuchime.jpg", photoWide: "img/products/gyuto-tsuchime.jpg", photoFit: "cover",
    gallery: [
      "img/products/gyuto-tsuchime.jpg",
      "img/products/gyuto-tsuchime-sq.jpg",
      "img/products/gyuto-tsuchime-handle.jpg",
      "img/products/gyuto-tsuchime-blade.jpg"
    ],
    detailImg: "img/products/gyuto-tsuchime-handle.jpg",
    anno: {
      photo: "img/products/gyuto-tsuchime-cut.png", aspect: 0.5071,
      points: { handle: [0.756, 0.189], heel: [0.533, 0.4], blade: [0.312, 0.709], tip: [0.029, 0.975] },
      bladeTitle: "het lemmet",
      notes: {
        handle: "African rosewood, achthoekig, met een zwart tussenstuk en een dun messing randje.",
        heel: "Waar hand en staal elkaar ontmoeten. Lemmetbreedte 4,8 cm (1,9 inch).",
        blade: "Zwart gesmeed met een gehamerd patroon boven een gepolijste snijkant. 2 mm dik, hardheid 56–58 HRC.",
        tip: "Voor het fijne werk: sjalot, kruiden, vis."
      }
    }
  },
  {
    id: "complete-set", kind: "set", style: "nami",
    name: "Complete Set",
    category: "Sets",
    price: 89.00, // the live price comes from Shopify
    oldPrice: 138.00,
    rating: 0,
    reviews: 0,
    badge: null,
    short: "Twee Gyuto's samen: het damascus-lemmet en het gehamerde lemmet.",
    inspo: "Twee koksmessen, twee karakters",
    steel: "",
    handle: "Gelakt pakkahout en achthoekig hout",
    hardness: "",
    length: "",
    origin: "",
    features: [
      "Twee Gyuto's: Gyuto Koksmes en Gyuto Koksmes Tsuchime in één set",
      "Twee karakters: één met een golvend damast-patroon, één met een gehamerd lemmet",
      "Allebei voor: ui, vis, vlees en kruiden",
      "Twee handvatten: gelakt pakkahout en African rosewood"
    ],
    why: "Twee koksmessen, twee karakters. Het ene met een golvend damast-patroon, het andere met een gehamerd lemmet. Allebei voor ui, vis, vlees en kruiden, elk met een eigen gevoel in de hand.",
    gauge: {
      tabs: true,
      ratios: [2400 / 385, 2400 / 349],
      knives: [
        { asset: 0, name: "Gyuto Koksmes", turn: { count: 56, ratio: 2206 / 420, inner: { left: 0.0522, top: 0.1231, width: 0.8947, height: 0.7539 }, m: "dikte", text: "2 mm", x: 0.32, ay: 0.375 }, marks: {
          lemmet: { type: "span", from: 0, to: 0.6, text: "20 cm" },
          totaal: { type: "span", from: 0, to: 1, text: "33,5 cm", row: 2 },
          gewicht: { type: "glow", from: 0, to: 1 }
        } },
        { asset: 1, name: "Gyuto Koksmes Tsuchime", turn: { count: 56, ratio: 1500 / 272, inner: { left: 0.0496, top: 0.097, width: 0.9007, height: 0.7225 }, m: "dikte", text: "2 mm", x: 0.32, ay: 0.30 }, marks: {
          lengte: { type: "span", from: 0, to: 0.6, text: "21 cm" },
          breedte: { type: "bracket", x: 0.5, y0: 0.09, y1: 0.98, text: "4,8 cm" },
          hardheid: { type: "glow", from: 0, to: 0.6 }
        } }
      ],
      stats: [
        { k: 0, m: "lemmet", v: "20", u: "cm", l: "lemmet" },
        { k: 0, m: "totaal", v: "33,5", u: "cm", l: "totale lengte" },
        { k: 0, m: "dikte", v: "2", u: "mm", l: "dikte lemmet" },
        { k: 0, m: "gewicht", v: "188", u: "g", l: "gewicht" },
        { k: 1, m: "lengte", v: "21", u: "cm", l: "lengte" },
        { k: 1, m: "breedte", v: "4,8", u: "cm", l: "breedte lemmet" },
        { k: 1, m: "dikte", v: "2", u: "mm", l: "dikte lemmet" },
        { k: 1, m: "hardheid", v: "56–58", u: "HRC", l: "hardheid" }
      ]
    },
    highlights: [{ v: "2", u: "messen", l: "in de set" }, { v: "20", u: "cm", l: "lemmet Gyuto" }, { v: "56–58", u: "HRC", l: "hardheid Tsuchime" }],
    includes: "Gyuto Koksmes + Gyuto Koksmes Tsuchime", use: "Ui, vis, vlees en kruiden",
    setItems: [
      { handle: "gyuto-koksmes-24-cm", specs: ["Lemmet 20 cm", "188 g", "Golvend patroon"] },
      { handle: "gyuto-koksmes-tsuchime", specs: ["Zwart gesmeed", "56–58 HRC", "African rosewood"] }
    ],
    specTable: {
      cols: ["Gyuto Koksmes", "Gyuto Koksmes Tsuchime"],
      rows: [
        ["Lengte", "33,5 cm totaal, 20 cm lemmet", "21 cm (8,3 inch)"],
        ["Breedte", "4 cm", "4,8 cm lemmet (1,9 inch)"],
        ["Dikte lemmet", "", "2 mm"],
        ["Hardheid", "", "56–58 HRC"],
        ["Gewicht", "188 g", ""],
        ["Afwerking", "Golvend damast-patroon", "Zwart gesmeed (black forged)"],
        ["Handvat", "Gelakt pakkahout", "African rosewood, achthoekig"],
        ["Voor", "Ui, vis, vlees en kruiden", "Ui, vis, vlees en kruiden"]
      ]
    },
    desc: "Twee koksmessen, twee karakters. De Gyuto met het golvende damast-patroon en de Gyuto met het gehamerde lemmet: allebei voor ui, vis, vlees en kruiden, elk met een eigen gevoel in de hand.",
    svg: "knife-gyuto",
    photo: "img/products/complete-set-cover.jpg",
    photoWide: "img/products/complete-set-cover.jpg",
    photoFit: "cover",
    gallery: [
      "img/products/complete-set-cover.jpg",
      "img/life-set-gyuto.jpg",
      "img/products/gyuto-240-cover.jpg",
      "img/products/gyuto-tsuchime.jpg",
      "img/products/gyuto-240-studio-handle.jpg",
      "img/products/gyuto-tsuchime-handle.jpg"
    ],
    detailImg: "img/products/gyuto-tsuchime-handle.jpg"
  },

  /* ---- Not listed yet (kept for later) ---- */
  { id: "nakiri-165", listed: false, name: "Nakiri Groentemes 165mm", category: "Nakiri", price: 99.00, oldPrice: null, rating: 4.7, reviews: 54, badge: "Nieuw", steel: "Aogami Super staal", handle: "Zwart pakkahout", hardness: "62 HRC", origin: "Handgesmeed in Echizen, Japan", desc: "Het rechte, brede lemmet van de Nakiri is speciaal ontworpen voor groenten.", svg: "knife-nakiri" },
  { id: "petty-120", listed: false, name: "Petty Universeel Mes 120mm", category: "Petty", price: 69.00, oldPrice: 79.00, rating: 4.6, reviews: 41, badge: null, steel: "VG-10 damast", handle: "Olijfhout", hardness: "60 HRC", origin: "Handgesmeed in Seki, Japan", desc: "Het kleine broertje van de Gyuto, perfect voor fijn snijwerk.", svg: "knife-petty" },
  { id: "yanagiba-270", listed: false, name: "Yanagiba Sashimimes 270mm", category: "Yanagiba", price: 259.00, oldPrice: null, rating: 5.0, reviews: 28, badge: "Premium", steel: "Shirogami #2 koolstofstaal", handle: "Ho-hout", hardness: "63 HRC", origin: "Handgesmeed in Sakai, Japan", desc: "Traditioneel eenzijdig geslepen lemmet voor sashimi en sushi.", svg: "knife-yanagiba" },
  { id: "deba-180", listed: false, name: "Deba Visfileermes 180mm", category: "Deba", price: 179.00, oldPrice: null, rating: 4.8, reviews: 33, badge: null, steel: "Shirogami #1 koolstofstaal", handle: "Magnolia", hardness: "62 HRC", origin: "Handgesmeed in Sakai, Japan", desc: "Zwaar, dik lemmet om vis te fileren.", svg: "knife-deba" },
  { id: "honing-rod", listed: false, name: "Keramische Aanzetstaal 25cm", category: "Accessoires", price: 39.00, oldPrice: null, rating: 4.5, reviews: 76, badge: null, steel: "Keramisch", handle: "Eikenhout", hardness: "—", origin: "Gemaakt in Japan", desc: "Onderhoud de snede van je mes tussen slijpbeurten door.", svg: "knife-honing" },
  { id: "whetstone-1000-6000", listed: false, name: "Slijpsteen Set 1000/6000", category: "Accessoires", price: 59.00, oldPrice: null, rating: 4.8, reviews: 88, badge: "Bestseller", steel: "Combinatiesteen", handle: "Incl. houder", hardness: "—", origin: "Gemaakt in Japan", desc: "Dubbelzijdige waterslijpsteen.", svg: "knife-whetstone" },
  { id: "saya-gyuto", listed: false, name: "Saya Beschermhoes Gyuto", category: "Accessoires", price: 29.00, oldPrice: null, rating: 4.6, reviews: 19, badge: null, steel: "—", handle: "Magnolia", hardness: "—", origin: "Gemaakt in Japan", desc: "Houten schede die de snede beschermt.", svg: "knife-saya" },
  { id: "kiritsuke-240", listed: false, name: "Kiritsuke 240mm", category: "Kiritsuke", price: 239.00, oldPrice: null, rating: 4.9, reviews: 17, badge: "Premium", steel: "SG2 damast", handle: "Ebbenhout", hardness: "63 HRC", origin: "Handgesmeed in Sakai, Japan", desc: "Het mes van de hoofdkok.", svg: "knife-kiritsuke" }
];

const LISTED_PRODUCTS = PRODUCTS.filter(p => p.listed !== false && !p.comingSoon);

function formatPrice(n){
  return "€ " + n.toFixed(2).replace(".", ",");
}


/* Coming soon: same product page as the knives on sale, but not buyable. No price, steel, hardness, origin or length until the supplier confirms them. */
const COMING_SOON = [
  {
    id: "bunka", kind: "kok", style: "nami", comingSoon: true, name: "Bunka Allroundmes", category: "Bunka",
    short: "Breed lemmet met een scherpe punt, voor precisiewerk.",
    inspo: "Japanse Bunka", handle: "Gelakt pakkahout", use: "Groenten, vlees en fijn snijwerk",
    features: [
      "Breed lemmet met een scherpe, hoekige punt",
      "Golvend patroon op het lemmet",
      "Handvat van gelakt, gelamineerd hout",
      "Voor groenten, vlees en fijn snijwerk"
    ],
    desc: "De Bunka is een Japans allroundmes met een breed lemmet en een scherpe, hoekige punt. Het is handig voor precisiewerk, zoals het insnijden van vlees of het fijn snijden van groenten. De breedte van het lemmet geeft je knokkels ruimte boven de plank.",
    photo: "img/products/bunka-170-cover.jpg",
    photoWide: "img/products/bunka-170-cover.jpg",
    photoFit: "cover",
    gallery: ["img/products/bunka-170.png", "img/products/bunka-170-h.png", "img/products/bunka-170-handle.jpg", "img/products/bunka-170-blade.jpg"],
    detailImg: "img/products/bunka-170-handle.jpg",
    anno: {
      photo: "img/products/bunka-170.png", aspect: 0.6131,
      points: { handle: [0.75, 0.17], heel: [0.54, 0.42], blade: [0.28, 0.68], tip: [0.06, 0.945] },
      bladeTitle: "het lemmet",
      notes: {
        handle: "Gelamineerd hout, met rode en zwarte lagen.",
        heel: "Waar hand en staal elkaar ontmoeten.",
        blade: "Breed en vlak, met een golvend patroon.",
        tip: "Scherpe, hoekige punt voor fijn werk."
      }
    }
  },
  {
    id: "sujihiki", kind: "vlees", style: "nami", comingSoon: true, name: "Sujihiki Vleesmes", category: "Sujihiki",
    short: "Lang en smal, voor dunne, gelijkmatige plakken.",
    inspo: "Japanse Sujihiki", handle: "Gelakt pakkahout", use: "Gebraad, ham en vis",
    features: [
      "Lang, smal lemmet met een golvend patroon",
      "Handvat van gelakt, gelamineerd hout",
      "Voor gebraad, ham, vis en dunne plakken"
    ],
    desc: "De Sujihiki is een lang en smal mes om in één haal te snijden. Het is gemaakt voor gebraad, ham en vis, waar je dunne, gelijkmatige plakken wilt zonder te zagen.",
    photo: "img/products/sujihiki-240-cover.jpg",
    photoWide: "img/products/sujihiki-240-cover.jpg",
    photoFit: "cover",
    gallery: ["img/products/sujihiki-240.png", "img/products/sujihiki-240-h.png", "img/products/sujihiki-240-handle.jpg", "img/products/sujihiki-240-blade.jpg"],
    detailImg: "img/products/sujihiki-240-handle.jpg",
    anno: {
      photo: "img/products/sujihiki-240.png", aspect: 0.5623,
      points: { handle: [0.77, 0.18], heel: [0.57, 0.39], blade: [0.29, 0.70], tip: [0.06, 0.965] },
      bladeTitle: "het lemmet",
      notes: {
        handle: "Gelamineerd hout, met rode en zwarte lagen.",
        heel: "Waar hand en staal elkaar ontmoeten.",
        blade: "Lang en smal, met een golvend patroon.",
        tip: "Een lange, fijne punt voor dunne plakken."
      }
    }
  },
  {
    id: "broodmes", kind: "brood", style: "nami", comingSoon: true, soldOut: true, name: "Broodmes", category: "Broodmes",
    short: "Met kartelsnede voor een knapperige korst.",
    handle: "Gelakt pakkahout", use: "Brood en tomaten",
    features: [
      "Kartelsnede die door de korst gaat zonder te platdrukken",
      "Golvend patroon op het lemmet",
      "Handvat van gelakt, gelamineerd hout"
    ],
    desc: "Een broodmes met een kartelsnede die door een harde korst gaat zonder het brood in te drukken. Ook handig voor tomaten en andere dingen met een stevige schil en een zachte binnenkant.",
    photo: "img/products/broodmes-cover.jpg",
    photoWide: "img/products/broodmes-cover.jpg",
    photoFit: "cover",
    gallery: ["img/products/broodmes-servetiemes.png", "img/products/broodmes-servetiemes-h.png", "img/products/broodmes-servetiemes-handle.jpg", "img/products/broodmes-servetiemes-blade.jpg"],
    detailImg: "img/products/broodmes-servetiemes-handle.jpg",
    anno: {
      photo: "img/products/broodmes-servetiemes.png", aspect: 0.5017,
      points: { handle: [0.77, 0.17], heel: [0.55, 0.38], blade: [0.28, 0.69], tip: [0.09, 0.965] },
      bladeTitle: "het lemmet",
      notes: {
        handle: "Gelamineerd hout, met rode en zwarte lagen.",
        heel: "Waar hand en staal elkaar ontmoeten.",
        blade: "Golvend patroon boven de kartelsnede.",
        tip: "De kartelsnede loopt door tot aan de punt."
      }
    }
  }
];
/* knives defined above in PRODUCTS but not on sale yet are shown as coming soon too */
PRODUCTS.filter(p => p.comingSoon && p.listed !== false).forEach(p => COMING_SOON.unshift(p));

function getProductById(id){
  return PRODUCTS.find(p => p.id === id) || COMING_SOON.find(p => p.id === id);
}

/* Shop categories in customer language. Each product has a kind that maps to one of these. */
const SHOP_CATEGORIES = [
  { id: "kok", label: "Koksmessen" },
  { id: "vlees", label: "Vleesmessen" },
  { id: "brood", label: "Broodmessen" },
  { id: "set", label: "Sets" }
];

/* Design styles/collections (finish + handle), independent of knife type.
   Each product has a style that maps to one of these. Add new lines here as they arrive. */
const STYLE_COLLECTIONS = [
  { id: "nami", kanji: "波", label: "Nami", sub: "de golvende lijn", desc: "Damast met een golvend patroon, handvat van rood-zwart gelakt pakkahout.", available: true },
  { id: "tsuchime", kanji: "槌目", label: "Tsuchime", sub: "het gehamerde lemmet", desc: "Een handgehamerde afwerking op het lemmet, handvat van licht hout.", available: true },
  { id: "kurouchi", kanji: "黒打", label: "Kurouchi", sub: "de ongepolijste smeedhuid", desc: "Een zwarte, ongepolijste smeedhuid op het lemmet, handvat van donker ebbenhout.", available: false },
  { id: "shiro", kanji: "白", label: "Shiro", sub: "de strakke, lichte lijn", desc: "Een spiegelend gepolijst lemmet, handvat van licht hout.", available: false }
];

/* Shopify handle -> local product id */
const KT_HANDLE_MAP = {
  "gyuto-koksmes-24-cm": "gyuto-240",
  "gyuto-koksmes-tsuchime": "gyuto-tsuchime",
  "complete-set": "complete-set",
  "santoku-18-cm": "santoku-180",
  "bunka-allroundmes": "bunka",
  "sujihiki-vleesmes": "sujihiki",
  "broodmes": "broodmes"
};
const KT_ID_TO_HANDLE = Object.fromEntries(Object.entries(KT_HANDLE_MAP).map(([h, i]) => [i, h]));
/* local image path ("img/products/x.jpg" or "img/x.jpg") -> theme asset url (window.KT_ASSETS is filled by Liquid) */
function ktAsset(p){
  if(!p) return p;
  const base = p.split("/").pop();
  return (window.KT_ASSETS && window.KT_ASSETS["kt-" + base]) || p;
}
